export default {
  en: {
    rateCodeList: 'Rate Code',
    editRateCode: 'Edit Rate Code',
    rateCode: 'Rate Code',
    code: 'Code',
    name: 'Name',
    status: 'Status',
    includeBreakfast: 'Include Breakfast',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    ratePeriod: 'Rate Period',
    period: 'Period',
    addPeriod: 'Add Period',
    addRoom: 'Add Room',
    applyEdit: 'Save Changes',
    editRateCodeSuccessTitle: 'Success',
    editRateCodeSuccessMessage: 'Update Rate Code Success.',
    alertOverlap: 'Period is overlap'
  },
  th: {
    rateCodeList: 'ประเภทเรท',
    editRateCode: 'สร้างเรทใหม่',
    rateCode: 'เรท',
    code: 'โค้ด',
    name: 'ชื่อ',
    status: 'สถานะ',
    includeBreakfast: 'รวมอาหารเช้า',
    yes: 'ใช่',
    no: 'ไม่ใช่',
    cancel: 'ยกเลิก',
    ratePeriod: 'ช่วงเวลา',
    period: 'ช่วงเวลา',
    addPeriod: 'เพิ่มช่วงเวลา',
    addRoom: 'เพิ่มห้อง',
    applyEdit: 'บันทึก',
    editRateCodeSuccessTitle: 'สำเร็จ',
    editRateCodeSuccessMessage: 'แก้ไขเรทสำเร็จ',
    alertOverlap: 'มีช่วงเวลาที่ซ้อนทับกัน'
  }
}
